import { render, staticRenderFns } from "./Projectinfor.vue?vue&type=template&id=29a18579&scoped=true&"
import script from "./Projectinfor.vue?vue&type=script&lang=js&"
export * from "./Projectinfor.vue?vue&type=script&lang=js&"
import style0 from "./Projectinfor.vue?vue&type=style&index=0&id=29a18579&scoped=true&lang=css&"
import style1 from "./Projectinfor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a18579",
  null
  
)

export default component.exports